import { render, staticRenderFns } from "./ThresholdReportTemplateEditor.vue?vue&type=template&id=40b3145c&scoped=true"
import script from "./ThresholdReportTemplateEditor.vue?vue&type=script&lang=js"
export * from "./ThresholdReportTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./ThresholdReportTemplateEditor.vue?vue&type=style&index=0&id=40b3145c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b3145c",
  null
  
)

export default component.exports